import { __read } from "tslib";
export function extractAriaAttributes(props) {
    return Object.entries(props).reduce(function (acc, _a) {
        var _b = __read(_a, 2), key = _b[0], val = _b[1];
        if (/^aria-(.*)/.test(key)) {
            acc.ariaAttributes[key] = val;
        }
        else {
            acc.restProps[key] = val;
        }
        return acc;
    }, {
        ariaAttributes: {},
        restProps: {},
    });
}
//# sourceMappingURL=extractAriaAttributes.js.map